











































































import Vue from 'vue';
import { SweepGraphCredentialUpdateModel } from '@/services/GeneratedApi';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { mapActions } from 'vuex';
import { confirmationHelper, MTablehelper } from '@/mixins';
import { MStoreExceptionResponseModel } from '@/types';

export default Vue.extend({
  mixins: [confirmationHelper, MTablehelper],

  data(this: any) {
    return {
      isTestSubmitting: false,
      isSubmitting: false,
      testResult: '' as '' | 'success' | 'fail',
      testResultNotification: '',
      localCredential: this.createLocalCredential(this.credential)
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'Add',
      validator: (value: string) => ['Add', 'Edit'].includes(value)
    },
    credential: {
      type: Object as () => SweepGraphCredentialUpdateModel,
      required: true
    }
  },
  computed: {
    title(this: any): string {
      return this.mode === 'Add' ? 'Add Microsoft Graph Credential' : 'Edit Microsoft Graph Credential';
    },
    clientSecretValidation(this: any) {
      return { required: this.mode === 'Add', maxLength: 1024 };
    },
    clientSecretPlaceholder(this: any): string {
      return this.mode === 'Add' ? '' : 'Leave blank to keep existing secret';
    }
  },

  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    async testCredential(this: any) {
      try {
        this.isTestSubmitting = true;
        if (this.localCredential.id && !this.localCredential.clientSecret) {
          await ApiConfiguration.apiWithoutNotification().sweepGraphCredentialsConfiguration.sweepGraphCredentialsConfigurationTestDetail(this.localCredential.id);
        } else {
          await ApiConfiguration.apiWithoutNotification().sweepGraphCredentialsConfiguration.sweepGraphCredentialsConfigurationTestCreate(this.localCredential);
        }
        this.testResult = 'success';
        this.testResultNotification = '';
      } catch (error) {
        const exceptionModel: MStoreExceptionResponseModel = error as any;
        this.testResult = 'fail';
        this.testResultNotification = exceptionModel?.notification ? exceptionModel.notification : 'An error occurred while testing the credentials';
      } finally {
        this.isTestSubmitting = false;
      }
    },

    initModalState(this: any) {
      this.isSubmitting = false;
      this.testResult = '';
      this.testResultNotification = '';
    },

    onModalHidden(this: any) {
      this.$emit('modal-cancelled');
    },

    onModalShow() {
      this.localCredential = Object.assign({}, this.credential);
      this.initModalState();
    },

    async onSubmitAsync(this: any) {
      this.isSubmitting = true;
      this.setApplicationDirty(false);
      try {
        if (this.mode === 'Add') {
          await ApiConfiguration.api().sweepGraphCredentialsConfiguration.sweepGraphCredentialsConfigurationCreate(this.localCredential);
        } else {
          await ApiConfiguration.api().sweepGraphCredentialsConfiguration.sweepGraphCredentialsConfigurationUpdate(this.localCredential);
        }
        this.$emit('modal-saved');
      } catch (error) {
        this.handleError?.(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async onCancelClicked(this: any, dirty: boolean) {
      if (dirty) {
        const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, true);
        if (hasUnsavedChangesToKeep) {
          return;
        }
      }
      this.setApplicationDirty(false);
      this.$emit('modal-cancelled');
    },
    onTestClicked(this: any) {
      this.testCredential();
    },
    createLocalCredential(credential: SweepGraphCredentialUpdateModel) {
      return JSON.parse(JSON.stringify(credential));
    }
  },
  components: {
    MStoreForm: () => import('@/components/shared/MStoreForm.vue'),
    MStoreFormInput: () => import('@/components/shared/MStoreFormInput.vue'),
    MStoreSpinnerButton: () => import('@/components/shared/MStoreSpinnerButton.vue'),
    MMStoreCheckbox: () => import('@/components/shared/MStoreFormCheckbox.vue')
  }
});
